import React from 'react';
import PropTypes from 'prop-types';
import PDFJS from "pdfjs-dist";

import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';
import Loader from "../../Parts/Loader";
import FIleDownload from "../../Icons/FileDownload";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import DialogModal from '../../common/DialogModal';
import { a4_vertical } from '../../../constants/a4-vertical.js';
import ArrowToolTip from "../../common/ArrowToolTip";
import * as URI from "urijs";
import moment from 'moment';
import { resolveAdditionalFileMaxPages } from '../../../utils/userOptionUtils';

const PizZip = require("pizzip");
const Docxtemplater = require("docxtemplater");

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
    color: "#181819",
  },

  contentContainer: {
    padding: "25px",
    margin: 0,
  },

  title: {
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "13px",
    marginBottom: "10px",
  },

  fileUploadContainer: {
    textAlign: "center",
    background: "#FFFFFF",
    fontSize: "12px",
    marginBottom: "30px",
    cursor: "pointer",
    boxSizing: 'border-box',
    width: '100%',
    padding: "20px 15px",
    display: 'flex',
    alignItems: 'center',
  },

  referenceText: {
    padding: "4px",
    background: "#F0F2F4",
    borderRadius: "2px",
    marginLeft: "5px",
  },

  emptyContainer: {
    padding: "50px",
    position: "relative",
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxSizing: "border-box",
    width: "100%",
  },

  container: {
    background: "#FFFFFF",
  },

  input: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    display: "none",
  },

  buttonContainer: {
    width: '100%',
    marginTop: '30px',
  },

  row: {
    padding: "15px 25px 15px 15px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    fontSize: "12px",
    textAlign: "start",
    border: "1px solid #D8DBDF",
    cursor: "pointer",
  },

  linkBtn: {
    textDecoration: "underline",
    cursor: "pointer",
    color: "#181819",

    "&:hover": {
      backgroundColor: "rgba(90, 91, 98, 0.2)",
    },
  },

  downloadBtn: {
    marginLeft: "auto",
    marginRight: "10px",
    width: "10px",
    height: "10px",

    '&:hover': {
      opacity: 0.5,
    }
  },

  caution: {
    marginBottom: 25,
    color: '#71737B',
    border: '1px solid #D8DBDF',
    background: '#ECEEF0',
    padding: 15,
    width: '100%',
    boxSizing: 'border-box',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    whiteSpace: 'pre-wrap'
  },
});

class LetterFileUploadDialog extends React.Component {
  state = {
    showNotification: false,
    message: '',
    messageType: '',
    a4DefaultWidth: a4_vertical.template_pages[0].finished_width,
    a4DefaultHeight: a4_vertical.template_pages[0].finished_height,
    dpi: a4_vertical.dpi,
    inchToMmRatio: a4_vertical.inch_mm_ratio,
    file: null,
    additionalFile: null,
    uploadFileSelect: null,
    usePastLetterOrder: null,
    isDrag: false,
  }

  componentDidMount() {
    this.props.getLetterOrderList({
      is_own: 'true',
      except_letter_order_addresses: 'true',
      paging: 1,
      per_page: 5,
      page: 1,
      has_additional_file: this.props.isAdditionalFile ? true : false,
    });
  }

  handleDrop = (e) => {
    e.preventDefault()
    const allowExtensions = '.(doc|docx)$';
    this.setState({
      isDrag: false,
      showNotification: false,
    });
    if (!e.dataTransfer.files[0].name.match(allowExtensions)) {
      this.displayNotification(
        `アップロード可能なデータ形式は.docx形式のみとなります。`,
        "error"
      );
    } else {
      this.handleChange(e);
    }
  };

  handleUploadClick = () => {
    this.fileUpload.click();
  };

  handleChange = (e) => {
    const { user } = this.props;
    let file;
    if (e && e.dataTransfer) {
      file = e.dataTransfer.files[0];
    } else {
      file = e.currentTarget.files[0];
    }

    if (file) {
      if (user && !user.letter_validation_flag) {
        this.setState({
          usePastLetterOrder: null,
          file: file,
          uploadFileSelect: 0,
        });
      } else {
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onerror = (e) => {
          console.log("内容物を読み込み失敗しました。" + e); // eslint-disable-line no-console

          this.setState({
            usePastLetterOrder: null,
            file: null,
            uploadFileSelect: null,
          });
        };

        reader.onload = (e) => {
          try {
            const content = e.target.result;
            let zip = new PizZip(content);
            let doc = new Docxtemplater().loadZip(zip);
            let text = doc.getFullText();

            let hasCompanyTag =
              /\{(会社名|組織名|company)\}|｛(会社名|組織名|company)｝/.test(
                text
              );
            let hasNameTag = /\{(名前|name)\}|｛(名前|name)｝/.test(text);

            if (this.props.isMulti && this.props.selectCount > 1) {
              // 複数の場合は必ず可変タグチェックを行う
              if (hasNameTag || hasCompanyTag) {
                this.setState({
                  usePastLetterOrder: null,
                  file: file,
                  uploadFileSelect: 0,
                });
              } else {
                let message = "";

                if (!hasCompanyTag && !hasNameTag) {
                  message =
                    "可変テキストがWordドキュメント内に見つかりません。";
                }

                this.displayNotification(
                  `${message}レター送付ガイドに従って内容物がアップロードされているか確認してください。`,
                  "error"
                );
                this.setState({
                  usePastLetterOrder: null,
                  file: null,
                  uploadFileSelect: null,
                });
                return;
              }
            } else {
              // 単一注文の場合は可変タグのチェックは注文時に行う
              // 画面には注意書きを表示する
              this.displayNotification(
                `注文が1通の場合、同日に同じ文面の注文があると注文時にエラーになることがございます。その場合はお手数でございますが可変テキストに置き換えたWordファイルをご利用ください。`,
                "success"
              );
              this.setState({
                usePastLetterOrder: null,
                file: file,
                uploadFileSelect: 0,
              });
            }
          } catch (e) {
            console.log("内容物を読み込み失敗しました。" + e); // eslint-disable-line no-console
            this.setState({
              usePastLetterOrder: null,
              file: null,
              uploadFileSelect: null,
            });
          }
        };
      }
    }
  };

  handleAdditionalDrop = (e) => {
    e.preventDefault();
    const allowExtensions = '.pdf$';
    this.setState({
      isDrag: false,
      showNotification: false,
    });
    if (!e.dataTransfer.files[0].name.match(allowExtensions)) {
      this.displayNotification(
        `アップロード可能なデータ形式は.pdf形式のみとなります。`,
        "error"
      );
    } else {
      this.handleAdditionalChange(e);
    }
  };

  handleAdditionalUploadClick = () => {
    this.additionalFileUpload.click();
  };

  validateAdditionalFile = (file) => {
    if (!this.props.validateAdditionalFile) {
      return Promise.resolve();
    }

    const formData = new FormData();
    formData.append('additional_file', file);
    return this.props.validateAdditionalFile(formData);
  };

  validatePdfPageSize = (page) => {
    const { a4DefaultWidth, a4DefaultHeight, dpi, inchToMmRatio } = this.state;
    let scale = 1;
    let viewport = page.getViewport(scale);

    // 単位をpixelをmmに変換
    let pdfWidth = (viewport.width / dpi) * inchToMmRatio;
    let pdfHeight = (viewport.height / dpi) * inchToMmRatio;

    // デフォルトサイズとの差分を計算
    let widthDiff = (a4DefaultWidth - pdfWidth) === 0 ? 0 : Math.abs((a4DefaultWidth - pdfWidth) / a4DefaultWidth);
    let heightDiff = (a4DefaultHeight - pdfHeight) === 0 ? 0 : Math.abs((a4DefaultHeight - pdfHeight) / a4DefaultHeight);

    const allowDiff = 0.01;
    if (widthDiff > allowDiff || heightDiff > allowDiff) {
      let errorMessage = "縦のA4サイズで再度アップロードしてください。";
      if (widthDiff > allowDiff && heightDiff > allowDiff) {
        errorMessage = "PDFの縦横のサイズが縦のA4サイズではありません。" + errorMessage;
      } else if (heightDiff > allowDiff) {
        errorMessage = "PDFの縦のサイズが縦のA4サイズではありません。" + errorMessage;
      } else if (widthDiff > allowDiff) {
        errorMessage = "PDFの横のサイズが縦のA4サイズではありません。" + errorMessage;
      }
      throw new Error(errorMessage);
    }
  };

  handleAdditionalChange = (e) => {
    const { user } = this.props;
    let file;
    if (e && e.dataTransfer) {
      file = e.dataTransfer.files[0];
    } else {
      file = e.currentTarget.files[0];
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e) => {
      PDFJS.getDocument(e.target.result).then((pdf) => {
        let numPages = pdf.numPages;
        const invalidPageCount = resolveAdditionalFileMaxPages(user);
        // ページ数チェック
        if (numPages > invalidPageCount) {
          this.displayNotification(
            `アップロードされたPDFが${numPages}ページあります。${invalidPageCount}ページ以下に変更してください。`,
            "error"
          );
          this.setState({
            usePastLetterOrder: null,
            additionalFile: null,
            uploadFileSelect: null,
          });
          return;
        }

        Promise.all(
          Array.from({ length: numPages }, (_, index) => pdf.getPage(index + 1))
        )
          .then((pages) => {
            pages.forEach((page) => {
              this.validatePdfPageSize(page);
            });
            return this.validateAdditionalFile(file);
          })
          .then(() => {
            if (file) {
              this.setState({
                usePastLetterOrder: null,
                additionalFile: file,
                uploadFileSelect: 0,
              });
            }
          })
          .catch((error) => {
            let message = '添付物の入力チェックに失敗しました。時間をおいて再度お試しください。';
            if (error && error.response && error.response.data && error.response.data.message) {
              message = error.response.data.message;
            } else if (error && error.message) {
              message = error.message;
            }
            this.displayNotification(message, 'error');
            this.setState({
              usePastLetterOrder: null,
              additionalFile: null,
              uploadFileSelect: null,
            });
          });
      });
    };
  };

  handleDownloadFile = (id) => {
    const query = {
      is_additional_file: this.props.isAdditionalFile
    };
    const path = `letter-orders/${id}/download`;

    let url = URI(process.env.REACT_APP_API_BASE_URL + path);
    url = url.query(query);
    window.open(url);
  };

  handlePreviewFile = (id) => {
    const query = {
      is_additional_file: this.props.isAdditionalFile
    };
    const path = `letter-orders/${id}/preview`;

    let url = URI(process.env.REACT_APP_API_BASE_URL + path);
    url = url.query(query);
    window.open(url, '_blank');
  };

  handleUploadFile = () => {
    const uploadFIle = this.props.isAdditionalFile ? this.state.additionalFile : this.state.file;
    this.props.changeUploadFIle(
      uploadFIle,
      this.state.usePastLetterOrder,
    )
    this.props.toggleDialog();
  };

  handleDragEnter = (e) => {
    // 子要素の場合は更新しない
    if (e.currentTarget.contains(e.relatedTarget)) return;
    this.setState({
      isDrag: true,
    });
  };

  handleDragLeave = (e) => {
    // 子要素の場合は更新しない
    if (e.currentTarget.contains(e.relatedTarget)) return;
    this.setState({
      isDrag: false,
    });
  };

  fileSizeError = () => {
    this.setState({
      usePastLetterOrder: null,
      additionalFile: null,
      uploadFileSelect: null,
    });
  };


  toggleLetterOrderFIle = (pastLetterOrder, idx) => {
    this.setState({
      file: null,
      additionalFile: null,
      usePastLetterOrder: pastLetterOrder,
      uploadFileSelect: idx,
    });
  };

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderFileUpload = () => {
    const { classes } = this.props;
    let uploadText, uploadButtonText;
    if (this.state.file || this.state.additionalFile) {
      uploadText = this.props.isAdditionalFile ? this.state.additionalFile.name : this.state.file.name;
      uploadButtonText = "再選択";
    } else if (this.state.usePastLetterOrder) {
      let fileName = this.props.isAdditionalFile ? this.state.usePastLetterOrder.original_additional_file_name : this.state.usePastLetterOrder.original_content_file_name;
      // 元のファイル名が保存されていない場合保管パスのファイル名を表示する
      if (!fileName) {
        fileName = this.props.isAdditionalFile ? this.state.usePastLetterOrder.additional_file_path : this.state.usePastLetterOrder.content_path;
        fileName = `${fileName.split("/").pop()}（${moment(this.state.usePastLetterOrder.instructed_at).format('YYYY年MM月DD日')}注文）`;
      }
      uploadText = fileName;
      uploadButtonText = "再選択";
    } else {
      uploadText = "ここにファイルをドラッグ＆ドロップ、または";
      uploadButtonText = "参照";
    }
    if (this.props.isAdditionalFile) {
      return (
        <div
          onDragOver={(e) => {
            e.stopPropagation();
            e.preventDefault(); // これがないとdropイベントが発火しない
          }}
          onDragEnter={(e) => {
            this.handleDragEnter(e);
          }}
          onDragLeave={(e) => {
            this.handleDragLeave(e);
          }}
          onDrop={(e) => this.handleAdditionalDrop(e)}
          onClick={this.handleAdditionalUploadClick}
          className={classes.fileUploadContainer}
          style={{
            border: this.state.isDrag ? "1px dashed #2E68F6" : 0 === this.state.uploadFileSelect ? "1px solid #2E68F6" : '1px solid #D9DBDF',
            justifyContent: (this.state.file || this.state.additionalFile || this.state.usePastLetterOrder) ? 'space-between' : 'center'
          }}
        >
          <span>{uploadText}</span>
          <span className={classes.referenceText}>{uploadButtonText}</span>
          <input
            type="file"
            accept=".pdf"
            onChange={this.handleAdditionalChange}
            ref={(fileUpload) => {
              this.additionalFileUpload = fileUpload;
            }}
            className={classes.input}
            onClick={(e) => {
              e.target.value = null;
            }}
          />
        </div>
      )
    } else {
      return (
        <div
          onDragOver={(e) => {
            e.stopPropagation();
            e.preventDefault(); // これがないとdropイベントが発火しない
          }}
          onDragEnter={(e) => {
            this.handleDragEnter(e);
          }}
          onDragLeave={(e) => {
            this.handleDragLeave(e);
          }}
          onDrop={(e) => this.handleDrop(e)}
          onClick={this.handleUploadClick}
          className={classes.fileUploadContainer}
          style={{
            border: this.state.isDrag ? "1px dashed #2E68F6" : 0 === this.state.uploadFileSelect ? "1px solid #2E68F6" : '1px solid #D9DBDF',
            justifyContent: (this.state.file || this.state.additionalFile || this.state.usePastLetterOrder) ? 'space-between' : 'center'
          }}
        >
          <span>{uploadText}</span>
          <span className={classes.referenceText}>{uploadButtonText}</span>
          <input
            type="file"
            accept="application/msword, .doc, .docx"
            onChange={this.handleChange}
            ref={(fileUpload) => {
              this.fileUpload = fileUpload;
            }}
            className={classes.input}
            onClick={(e) => {
              e.target.value = null;
            }}
          />
        </div>
      )
    }
  };

  renderRow = (letterOrder, idx, isLast) => {
    const { classes } = this.props;
    let fileName = this.props.isAdditionalFile ? letterOrder.original_additional_file_name : letterOrder.original_content_file_name;
    // 元のファイル名が保存されていない場合保管パスのファイル名を表示する
    if (!fileName) {
      fileName = this.props.isAdditionalFile ? letterOrder.additional_file_path : letterOrder.content_path;
      fileName = fileName ? fileName.split("/").pop() : fileName;
    }

    return (
      <div
        className={classes.row}
        key={letterOrder.id}
        style={{
          border: idx === this.state.uploadFileSelect ? "1px solid #2E68F6" : '1px solid #D8DBDF',
          borderBottom: idx === this.state.uploadFileSelect ? "1px solid #2E68F6" :
            isLast ? "1px solid #D8DBDF" : "1px solid #FFFFFF"
        }}
        onClick={() => this.toggleLetterOrderFIle(letterOrder, idx)}
      >
        <Typography variant="subheading" style={{ fontSize: "12px", width: "50%" }}>{fileName}</Typography>
        <Typography variant="subheading" style={{ fontSize: "12px", width: "30%" }}>{moment(letterOrder.instructed_at).format('YYYY年MM月DD日')}注文</Typography>
        {!this.props.isAdditionalFile && (
          <ArrowToolTip text={"過去提出したWordファイルをPDF化して表示します。元のWordファイルの表示から崩れる場合がございますが、レター作成は元のWordファイルより行いますので、ご安心くださいませ。"}>
            <Typography
              variant="subheading"
              style={{ fontSize: '12px', textDecoration: 'underline' }}
              onClick={() => this.handlePreviewFile(letterOrder.id)}
              className={classes.editFilter}>
              プレビュー
            </Typography>
          </ArrowToolTip>
        )}
        <IconButton
          color="default"
          title="ファイルダウンロード"
          className={classes.downloadBtn}
          onClick={() => this.handleDownloadFile(letterOrder.id)}
        >
          <FIleDownload />
        </IconButton>
      </div>
    );
  };

  render() {
    const { classes, toggleDialog, isOpen, letterOrderList } = this.props;
    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }
    return (
      <DialogModal
        title="レターデータをアップロード"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.caution}>
          {this.props.isAdditionalFile
            ? "縦A4サイズ 2ページ以内に収まるようお願いいたします。\n2ページの場合は両面印刷となります。"
            : "Wordの用紙サイズはA4に設定してください。\nA4一枚の表面のみの印刷とさせていただいておりますので、\n1ページに収まるようお願いいたします。"
          }
        </div>
        <div className={classes.title}>コンピューターから選択</div>
        {this.renderFileUpload()}
        <div className={classes.title}>最近使用したファイルから選択</div>
        {(() => {
          if (
            this.props.isLoading &&
            letterOrderList.length === 0
          ) {
            return (
              <div className={classes.emptyContainer}>
                <Loader type="color" size="large" />
              </div>
            );
          } else if (letterOrderList.length === 0) {
            return (
              <div className={classes.emptyContainer}>
                <Typography variant="body2" style={{ color: "#71737B" }}>
                  最近使用したファイルはありません。
                </Typography>
              </div>
            );
          } else {
            return (
              <div className={classes.container}>
                {letterOrderList.map((letterOrder, i) =>
                  this.renderRow(letterOrder, i + 1, i === letterOrderList.length - 1)
                )}
              </div>
            );
          }
        })()}

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.handleUploadFile}
            disabled={!this.state.additionalFile && !this.state.file && !this.state.usePastLetterOrder}
            text="確定"
            size="large"
            style={{ width: "100%", height: "42px" }}>
          </Button>
        </div>
        {notification}
      </DialogModal>
    );
  }
}

LetterFileUploadDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isAdditionalFile: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  letterOrderList: PropTypes.array,
  getLetterOrderList: PropTypes.func.isRequired,
  changeUploadFIle: PropTypes.func.isRequired,
  validateAdditionalFile: PropTypes.func,
  user: PropTypes.object,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMulti: PropTypes.bool,
};

export default withStyles(styles)(LetterFileUploadDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/LetterFileUploadDialog.jsx